/**
 * Title Format Utilities
 * Handles conversion between rich-text title format and plain text
 */

import { extractPlainText } from './tiptapPlainText';
import { renderTipTapToHTML } from './tiptapRenderer';

/**
 * Get plain text from title (handles both string and rich-text format)
 */
export const getTitlePlainText = (title) => {
  if (typeof title === 'string') {
    return title;
  }
  if (title && typeof title === 'object') {
    // New format: {format: "tiptap", json: {}, plain_text: ""}
    if (title.plain_text) {
      return title.plain_text;
    }
    if (title.json) {
      return extractPlainText(title.json);
    }
  }
  return '';
};

/**
 * Format title for submission (converts TipTap JSON to structured format)
 */
export const formatTitleForSubmission = (titleJson) => {
  if (!titleJson || typeof titleJson !== 'object') {
    return '';
  }
  const plainText = extractPlainText(titleJson);
  return {
    format: 'tiptap',
    json: titleJson,
    plain_text: plainText
  };
};

/**
 * Get title JSON for editor (handles both formats)
 */
export const getTitleJson = (title) => {
  if (typeof title === 'string') {
    // Legacy format - convert to TipTap JSON
    return {
      type: 'doc',
      content: [
        {
          type: 'paragraph',
          content: [{ type: 'text', text: title }]
        }
      ]
    };
  }
  if (title && typeof title === 'object' && title.json) {
    return title.json;
  }
  return {
    type: 'doc',
    content: [
      {
        type: 'paragraph',
        content: [{ type: 'text', text: '' }]
      }
    ]
  };
};

/**
 * Get title HTML from title (handles both string and rich-text format)
 * Returns HTML string for rendering with dangerouslySetInnerHTML
 */
export const getTitleHtml = (title) => {
  if (typeof title === 'string') {
    // Legacy format - escape HTML and return as string
    const div = document.createElement('div');
    div.textContent = title;
    return div.innerHTML;
  }
  if (title && typeof title === 'object') {
    // New format: {format: "tiptap", json: {}, plain_text: ""}
    if (title.json) {
      return renderTipTapToHTML(title.json);
    }
    // If it's already a TipTap JSON doc, render it directly
    if (title.type === 'doc' && Array.isArray(title.content)) {
      return renderTipTapToHTML(title);
    }
  }
  return '';
};
